module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/me-4c8b84af010134d56b90d1ce18ad9e6b.svg";